import styled, { css } from 'styled-components';
import { ELEMENT_MAX_WIDTH } from 'styles';

export default {
  Wrapper: styled.label`
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    display: inline-flex;
    flex: 0 1 auto;
    width: 100%;
    justify-content: flex-start;
    align-items: start;
    cursor: auto;
    ${props => props.verticalLayout ? css`
      flex-direction: column;
      align-items: flex-start;
    ` : css`
      flex-direction: row;
      align-items: start;
    `}
    ${props => props.maxWidth ? css`
      max-width: ${ELEMENT_MAX_WIDTH};
    ` : css`
      max-width: 100%;
    `}
`
};